/* eslint-disable object-property-newline */
// eslint-disable-next-line lines-around-comment
import React, { useEffect, useState } from 'react';
// @ts-ignore
import Avatar from '../../../base/avatar/components/Avatar';
import StatelessAvatar from '../../../base/avatar/components/web/StatelessAvatar';
import { getInitials } from '../../../base/avatar/functions';
import BaseTheme from '../../../base/ui/components/BaseTheme.web';
import statsEmitter from '../../../connection-indicator/statsEmitter';
import TimeElapsed from './TimeElapsed';
import Timeline from './Timeline';
const SpeakerStatsItem = (props) => {
    const { participantId } = props;
    const rowDisplayClass = `row item ${props.hasLeft ? 'has-left' : ''}`;
    const nameTimeClass = `name-time${props.showFaceExpressions ? ' expressions-on' : ''}`;
    const timeClass = `time ${props.isDominantSpeaker ? 'dominant' : ''}`;
    const [{ download, upload }, setBitrate] = useState({
        download: 0,
        upload: 0
    });
    useEffect(() => {
        // eslint-disable-next-line require-jsdoc
        function _onStatsUpdated(stats) {
            setBitrate((stats === null || stats === void 0 ? void 0 : stats.bitrate) || { download: 0, upload: 0 });
        }
        statsEmitter.subscribeToClientStats(participantId, _onStatsUpdated);
        return () => {
            statsEmitter.unsubscribeToClientStats(participantId, _onStatsUpdated);
        };
    }, [participantId]);
    return (React.createElement("div", { key: props.participantId },
        React.createElement("div", { className: rowDisplayClass },
            React.createElement("div", { className: 'avatar' }, props.hasLeft ? (React.createElement(StatelessAvatar, { className: 'userAvatar', color: BaseTheme.palette.ui04, initials: getInitials(props.displayName) })) : (React.createElement(Avatar
            // @ts-ignore
            , { 
                // @ts-ignore
                className: 'userAvatar', participantId: props.participantId }))),
            React.createElement("div", { className: nameTimeClass },
                React.createElement("div", { "aria-label": props.t('speakerStats.speakerStats'), className: 'display-name' }, props.displayName),
                React.createElement("div", { "aria-label": props.t('speakerStats.speakerTime'), className: timeClass },
                    React.createElement(TimeElapsed, { time: props.dominantSpeakerTime })),
                React.createElement("div", { "aria-label": props.t('connectionindicator.bitrate'), className: 'speaker-stats-item__bitrate' },
                    React.createElement("span", { className: 'connection-info__download' }, "\u2193 \u00A0"),
                    download ? `${download} Kbps` : 'N/A',
                    "\u00A0 \u00A0",
                    React.createElement("span", { className: 'connection-info__upload' }, "\u2191 \u00A0"),
                    upload ? `${upload} Kbps` : 'N/A')),
            props.showFaceExpressions
                && React.createElement(Timeline, { faceLandmarks: props.faceLandmarks })),
        React.createElement("div", { className: 'separator' })));
};
export default SpeakerStatsItem;
